export default __webpack_public_path__ + "static/media/0217.ee841ed5.jpg";